import { render, staticRenderFns } from "./LocationView.vue?vue&type=template&id=1308bfbb"
import script from "./LocationView.vue?vue&type=script&lang=ts"
export * from "./LocationView.vue?vue&type=script&lang=ts"
import style0 from "./LocationView.vue?vue&type=style&index=0&id=1308bfbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports